import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";
import { forwardRef } from "react";

import { cn } from "../../../lib";

const cardVariants = cva("overflow-hidden bg-white shadow sm:rounded-lg", {
  variants: {
    variant: {
      default: "",
      header: "",
      none: "",
    },
    size: {
      default: "",
    },
  },
  defaultVariants: {
    variant: "default",
    size: "default",
  },
});

interface CardProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof cardVariants> {}

const Card = forwardRef<HTMLDivElement, CardProps>((props, ref) => {
  const { variant = "default", size = "default", className, ...rest } = props;
  return (
    <div
      className={cn(cardVariants({ variant, size }), className)}
      {...rest}
      ref={ref}
    >
      {props.children}
    </div>
  );
});

Card.displayName = "Card";

export default Card;
export { cardVariants };
export type { CardProps };
